import * as React from "react";
import { Chip, type ChipProps } from "@mui/material";

interface ReportStatusBadgeProps {
  status: string | null | undefined;
}

const COLOR_MAP: Record<string, ChipProps["color"]> = {
  available: "success",
  generated: "success",
  passed: "success",
  degraded: "warning",
  unavailable: "default",
  not_generated: "default",
  failed: "error",
};

/**
 * Maps a report's availability/generation status to a colored chip. A
 * distinct vocabulary from `HealthBadge`/`PositionBadge` (available/
 * unavailable/not_generated are report-specific terms, not health or
 * order states), so this is a genuinely new small component rather than
 * a duplicate.
 */
export function ReportStatusBadge({ status }: ReportStatusBadgeProps): React.JSX.Element {
  const normalized = (status ?? "unknown").toLowerCase();
  const color = COLOR_MAP[normalized] ?? "default";
  return <Chip size="small" label={status ?? "unknown"} color={color} variant="outlined" />;
}
